export enum DeploymentType {
  LOCAL = 'local',
  UAT = 'uat',
  PROD = 'prod'
}

export class DeploymentUtils {

  static getDeploymentType(host: string): DeploymentType {
    const normalizedHost = (host || '').toLowerCase();
    // Strip any port so hosts like `app.stormfieldcapital.local:3002` are detected as local.
    const hostname = normalizedHost.split(':')[0];

    const isLocalHost =
      !normalizedHost ||
      normalizedHost.startsWith('localhost') ||
      normalizedHost.startsWith('127.0.0.1') ||
      normalizedHost.startsWith('0.0.0.0') ||
      normalizedHost.startsWith('::1') ||
      hostname.endsWith('.local');

    if (isLocalHost) {
      return DeploymentType.LOCAL;
    }

    if (normalizedHost.includes('app.stormfieldcapital.com')) return DeploymentType.PROD;
    return DeploymentType.UAT;
  }

}
